export const HEADER_HEIGHT_PX = 81;

export const FOOTER_BREAKPOINT_PX = 875;
export const FOOTER_BREAKPOINT_LG_PX = 1005;

export const FOOTER_HEIGHT_MOBILE_PX = 136;
export const FOOTER_HEIGHT_DESKTOP_PX = 100;
